import { api } from './BaseApi'
import {
  ICompareReportRequest,
  ICompareReportResponse,
} from './dto/CompareReportDto'
import { createQueryStringSmart } from 'utils/createQueryString'

export const compareReportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCompareReport: builder.query<
      ICompareReportResponse,
      ICompareReportRequest
    >({
      query: (params) => ({
        url: `/compare_report/${createQueryStringSmart(params)}`,
      }),
      providesTags: ['CompareReport'],
    }),
  }),
})

export const { useGetCompareReportQuery } = compareReportApi
